<template>
	<div class="box">
		<!-- 查询区域 -->
		<div class="search-container">
			<div style="font-size: 16px; font-weight: bold; padding-bottom: 16px;">查询商品</div>

			<!-- 搜索表单 -->
			<div class="search-form">
				<!-- 商品名称 -->
				<div class="input-wrapper">
					<label class="input-label">商品名称：</label>
					<el-input v-model="req.name" placeholder="请输入商品名称" clearable style="background-color: #F2F3F5;" />
				</div>

				<!-- 分类选择 -->
				<div class="input-wrapper">
					<label class="input-label">分类：</label>
					<el-select v-model="req.customizeLabelId" placeholder="请选择分类" clearable filterable remote
						:remote-method="handleCategoryRemoteSearch" :loading="categoryLoading"
						style="width: 100%; background-color: #F2F3F5;">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
				</div>

				<!-- 分隔线 -->
				<div class="divider"></div>

				<!-- 查询按钮 -->
				<div class="search flexc" @click="search" style="cursor: pointer;">
					<img src="/images/goodsList/search.svg" width="14px" height="14px" alt="" />
					<div style="margin-left: 4px; font-size: 14px;">查询</div>
				</div>
			</div>
		</div>

		<!-- 新建 & 批量操作 -->
		<div class="flexb" style="margin: 20px;">
			<router-link to="/goodsList/newGoods" style="text-decoration: none;">
				<div class="search flexc">
					<i class="el-icon-plus" style="padding-left: 4px;"></i>
					新建
				</div>
			</router-link>

			<div class="flexc">
				<!-- <div class="out flexc" @click="batchDelist" style="cursor: pointer; ">
					<i class="el-icon-bottom" style="padding-left: 4px;"></i>
					下架
				</div> -->
				<div class="del flexc" @click="deleteSelected" style="cursor: pointer;">
					<i class="el-icon-delete" style="padding-left: 4px;"></i>
					删除
				</div>
				<!-- <div class="down flexc">
					<i class="el-icon-download" style="padding-left: 4px;"></i>
					下载
				</div> -->
			</div>
		</div>

		<!-- 表格区域 -->
		<template v-if="!$route.path.startsWith('/goodsList/newGoods')">
			<el-table ref="etbl" class="custom-header-table" :height="tblHeight" v-loading="tableLoading"
				:data="tableDatas" @selection-change="handleSelectionChange">
				<el-table-column type="selection"></el-table-column>
				<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>

				<el-table-column label="商品类别" width="200" align="center">
					<template slot-scope="scope">
						<div>{{ getGoodsCategoryName(scope.row) }}</div>
					</template>
				</el-table-column>

				<el-table-column label="商品名称" width="220" align="center">
					<template slot-scope="scope">
						<div class="ellipsis">{{ scope.row.name }}</div>
					</template>
				</el-table-column>

				<el-table-column label="商品数量" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.num }}</div>
					</template>
				</el-table-column>

				<el-table-column label="商品原价" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatPrice(getOriginalPriceValue(scope.row)) }}</div>
					</template>
				</el-table-column>

				<el-table-column label="商品现价" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatPrice(getCurrentPriceValue(scope.row)) }}</div>
					</template>
				</el-table-column>

				<el-table-column label="商品折扣" align="center">
					<template slot-scope="scope">
						<div class="price">{{ getDiscountValue(scope.row) }}折</div>
					</template>
				</el-table-column>

				<el-table-column label="商品图片" width="120" align="center">
					<template slot-scope="scope">
						<img v-if="getImageUrl(scope.row)" width="84" height="84" :src="getImageUrl(scope.row)" />
						<div v-else>--</div>
					</template>
				</el-table-column>

				<el-table-column label="商品属性" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.recentState == 0 ? '促' : "新" }}</div>
					</template>
				</el-table-column>

				<el-table-column label="商品详情" width="260" align="center">
					<template slot-scope="scope">
						<div class="ellipsis">{{ scope.row.detailText || scope.row.desc || '--' }}</div>
					</template>
				</el-table-column>

				<el-table-column label="操作" width="100" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页组件 -->
			<div class="flexe" style="margin-top: 12px;">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage2" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total" background>
				</el-pagination>
			</div>
		</template>

		<router-view />
	</div>
</template>

<script>
	import {
		goodsApi
	} from "@/api";

	export default {
		name: "GoodsList",
		data() {
		return {
			tableLoading: false,
			tblHeight: null,

			// 搜索与排序条件
				req: {
					hot: 1,
					orderby: 'hot_sort asc',
					name: '',
					state: '',
					customizeLabelId: ''
				},

				// 表格数据
				tableDatas: [],

				// 分页控制（用于请求参数）
				currentPage2: 1,
				pageSize: 10,
				total: 0,

				// 多选删除
				multipleSelection: [],

				// 分类选项
				options: [],
				categoryLoading: false,
				categorySearchTimer: null
			};
		},
		created() {
			this.getCustomizeLabelOptions();
			this.search(); // 首次进入页面执行一次查询（带分页）
			// if (this.$route.query.refresh) {
			// 	this.search();
			// 	this.$router.replace({
			// 		path: '/goodsList'
			// 	});
			// }

		},
		beforeDestroy() {
			if (this.categorySearchTimer) {
				clearTimeout(this.categorySearchTimer);
			}
		},

		watch: {
			async '$route.query.refresh'(newVal) {
				if (newVal) {
					await this.getCustomizeLabelOptions();
					this.search(); // 刷新列表
					// 清除查询参数，避免重复刷新
					this.$router.replace({
						path: '/goodsList'
					});
				}
			},
			'$route.path'(newPath, oldPath) {
				if (newPath === '/goodsList' && oldPath && oldPath.indexOf('/goodsList/newGoods') === 0) {
					this.getCustomizeLabelOptions();
				}
			}
		},
		methods: {
			getStoreId() {
				return this.$store.getters['auth/storeId'];
			},
			normalizeId(value) {
				if (value === null || value === undefined || value === '') {
					return null;
				}
				const idNumber = Number(value);
				return Number.isNaN(idNumber) ? value : idNumber;
			},
			normalizeLabelName(value) {
				return typeof value === 'string' ? value.trim() : '';
			},
			async getCustomizeLabelOptions(labelLike = '') {
				this.categoryLoading = true;
				try {
					const params = {
						pageNo: 1,
						pageSize: 100,
						storeId: this.getStoreId()
					};
					const keyword = this.normalizeLabelName(labelLike);
					if (keyword) {
						params.labelLike = keyword;
					}
					const response = await goodsApi.queryCustomizeLabelPage(params);
				if ((response.code === 0 || response.code === 200) && response.data?.list) {
					this.options = response.data.list
						.filter(item => item && item.deleted !== true && item.id !== undefined && item.id !== null && this.normalizeLabelName(item.labelName))
						.map(item => ({
							label: this.normalizeLabelName(item.labelName),
							value: this.normalizeId(item.id)
						}));
				} else {
						this.$message.error(response.msg || '获取分类失败');
					}
				} catch (err) {
					console.error('获取分类错误:', err);
					this.$message.error('网络异常，无法获取分类');
				} finally {
					this.categoryLoading = false;
				}
			},
			handleCategoryRemoteSearch(query) {
				if (this.categorySearchTimer) {
					clearTimeout(this.categorySearchTimer);
				}
				this.categorySearchTimer = setTimeout(() => {
					this.getCustomizeLabelOptions(this.normalizeLabelName(query));
				}, 300);
			},

			// 统一的查询方法（含分页、搜索）
			async search() {
				this.tableLoading = true;
				try {
					const params = {
						pageNo: this.currentPage2,
						pageSize: this.pageSize,
						storeId: this.getStoreId()
					};

					// 添加可选搜索条件
					if (this.req.name) {
						params.goodsNameLike = this.req.name.trim();
					}
					if (this.req.customizeLabelId) {
						params.customizeLabelId = this.req.customizeLabelId;
					}

					const response = await goodsApi.getGoodsList(params);

					if ((response.code === 0 || response.code === 200) && response.data) {
						this.tableDatas = response.data.list || [];
						this.total = response.data.total || response.data.count || 0;
					} else {
						this.$message.error(response.msg || '获取商品列表失败');
					}
				} catch (err) {
					console.error('获取商品列表错误:', err);
					this.$message.error('请求失败，请检查网络');
				} finally {
					this.tableLoading = false;
				}
			},

		// 多选变化
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		getGoodsCategoryName(row) {
			if (!row) {
				return '--';
			}
			const directName = this.normalizeLabelName(row.customizeLabelName) || this.normalizeLabelName(row.goodsTypeName);
			if (directName) {
				return directName;
			}
			const labelId = this.normalizeId(row.customizeLabelId || row.goodsTypeId);
			if (labelId === null) {
				return '--';
			}
			const matched = this.options.find(item => this.normalizeId(item.value) === labelId);
			return matched?.label || '--';
		},

		formatPrice(value) {
			if (value === null || value === undefined || value === '') {
				return '--';
			}
			return `￥${value}`;
		},
		getOriginalPriceValue(row) {
			if (row && row.originalPrice != null ) {
				return row.originalPrice;
			}
			return null;
		},
		getCurrentPriceValue(row) {
			if (row && row.currentPrice != null ) {
				return row.currentPrice;
			}
			return null;
		},
		getDiscountValue(row) {
			const originalPrice = Number(this.getOriginalPriceValue(row));
			const currentPrice = Number(this.getCurrentPriceValue(row));
			if (!Number.isFinite(originalPrice) || originalPrice <= 0 || !Number.isFinite(currentPrice) || currentPrice < 0) {
				return '0.0';
			}
			return ((currentPrice / originalPrice) * 10).toFixed(1);
		},
		getImageUrl(row) {
			if (row && row.imageUrl) {
				return row.imageUrl;
			}
			return '';
		},
		handleEdit(row) {
			const id = row && (row.promoGoodsId || row.id);
			if (!id) {
				this.$message.warning('未找到商品ID，无法编辑');
				return;
			}
			this.$router.push({
				path: '/goodsList/newGoods',
				query: {
					id
				}
			});
		},

		// 批量下架
		async batchDelist() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请至少选择一条商品进行下架');
				return;
			}

			const promoGoodsIdList = this.multipleSelection
				.map(item => item.promoGoodsId || item.id)
				.filter(id => id !== undefined && id !== null && id !== '');

			if (promoGoodsIdList.length === 0) {
				this.$message.warning('未找到可下架的商品ID');
				return;
			}

			try {
				await this.$confirm(
					`确定要下架选中的 ${promoGoodsIdList.length} 个商品吗？`,
					'提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}
				);

				const response = await goodsApi.delistPromoGoodsBatch({
					promoGoodsIdList
				});

				if (response.code === 0 || response.code === 200) {
					this.$message.success('下架成功');
					this.search();
				} else {
					this.$message.error(response.msg || '下架失败');
				}
			} catch (err) {
				if (err !== 'cancel') {
					console.error('下架错误:', err);
					this.$message.error('下架请求失败');
				}
			}
		},

		// 删除选中商品
		async deleteSelected() {
				if (this.multipleSelection.length === 0) {
					this.$message.warning('请至少选择一条商品进行删除');
					return;
				}

				try {
					await this.$confirm(
						`确定要删除选中的 ${this.multipleSelection.length} 个商品吗？`,
						'提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}
					);

					const promoGoodsIdList = this.multipleSelection.map(item => item.promoGoodsId || item.id);
					const response = await goodsApi.deleteGoods({
						promoGoodsIdList
					});

					if (response.code === 0 || response.code === 200) {
						this.$message.success('删除成功');
						this.search(); // 重新查询当前页数据
					} else {
						this.$message.error(response.msg || '删除失败');
					}
				} catch (err) {
					if (err !== 'cancel') {
						console.error('删除错误:', err);
						this.$message.error('删除请求失败');
					}
				}
			},

			// 每页条数改变
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage2 = 1; // 回到第一页
				this.search();
			},

			// 当前页改变
			handleCurrentChange(val) {
				this.currentPage2 = val;
				this.search();
			}
		}
	};
</script>

<style lang="scss" scoped>
	/* 样式保持不变 */
	.box {
		width: 100%;
		height: 100%;
		background-color: #fff;
	}

	.out {
		width: 82px;
		height: 32px;
		background-color: #0D99FF;
		color: #fff;
		margin-right: 24px;
		cursor: pointer;
	}
</style>
